import User from "@/models/User.js";

export default {
	state: () => ({permissions: [], configjsonRequiredNotify: false, configjsonRequired: ""}),
	actions: {
		getPermissions: async function ({state, commit}) {
			const userSession = new User();
			const user = await userSession.getUser();
			const permissionsList = user.permissions;
			commit("setPermissions", permissionsList);
		},
		/*  showConfigjsonRequiredNotify({ state, commit }, dataFromRoute) {
            commit('changeConfigjsonRequiredNotify', dataFromRoute)
        }, */
	},
	mutations: {
		setPermissions(state, permissions) {
			state.permissions = permissions;
		},
		/* changeConfigjsonRequiredNotify(state, val) {
            state.configjsonRequiredNotify = !state.configjsonRequiredNotify
            state.configjsonRequired = val.name
        }, */
	},
	getters: {
		checkPermission: (state) => (name) => {
			return state.permissions.some((permission) => permission.permission_name === name);
		},
		/* getConfigjsonRequiredNotifyStatus: (state) => () => {
            return state.configjsonRequiredNotify
        },
        getConfigjsonRequiredName: (state) => () => {
            return state.configjsonRequired
        }, */
	},
};
